import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useServiceGroupsV2 = (options = {}) => {
  const { performHttpRequests } = options || {}

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceGroupsV2 } = entities

  useReduxAction('serviceGroupsV2', 'loadServiceGroupsV2', {}, [performHttpRequests], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return performHttpRequests && !loaded && !loading && !errors.length
    },
  })

  return {
    serviceGroupsV2,
  }
}

export default useServiceGroupsV2
